import React from 'react';
import { createIcon } from './create-icon';
import './icon-pin.scss';

export const IconPin = createIcon(<div className="icon-pin" />);

export const IconPinActive = createIcon(<div className="icon-pin-active" />);
